import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement, ISelectFieldSingleItem } from '../Form/DynamicForm'
import { InputLabel, ListSubheader, MenuItem, Select } from '@mui/material'
import { updateAllLocations, useReturnAllLocations } from '../../features/locations/locationsSlice'
import LocationsApp, { ILocationModel } from '../../features/locations/LocationsApp'
import Countries from '../../features/locations/Countrries'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { updateAllWarehouses, useReturnAllWarehouses } from '../../features/warehouses/warehousesSlice'
import WarehousesApp, { IWarehouseModel } from '../../features/warehouses/WarehousesApp'
import { updateAllCategories, useReturnAllCategories } from '../../features/categories/categoriesSlice'
import CategoriesApp, { ICategoryModel } from '../../features/categories/CategoriesApp'
import { IUserModel } from '../../services/user'
import UsersApp from '../../features/user/UsersApp'

export default function UsersSelectFieldElement(props: IBaseDynamicFormElement) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, handleOnChange, data, displayForItem, addNoneItem } = props

    const [items, setItems] = useState<Array<IUserModel>>([])
    const usersApp = new UsersApp()

    const [value, setValue] = useState<any>("")

    const labelId = "label_of_" + id


    const renderItems = () => {

        return items.map((item, index: number) => <MenuItem value={item.id} key={index}>{item.first_name} {item.last_name} - {item.email}</MenuItem>)
    }

    useEffect(() => {
        setValue(data.value)
    }, [data.value])

    useEffect(() => {

        usersApp.listOfInstances(1, "", true)
            .then(response => {

                const data = response.data
                setItems(data)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })

    }, [])

    return(
        <>
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    labelId={labelId}
                    id={id}
                    value={value}
                    label={label}
                    name={id}
                    onChange={(e) => handleOnChange(id, e.target.value)}
                    error={data.helperTextType === "error" ? true : false}
                    disabled={data.disabled}
                    fullWidth={fullWidth}
                >
                    {addNoneItem && <MenuItem value="">None</MenuItem>}
                    {renderItems()}
                </Select>
        </>
    )
}